export enum PaymentMethods{
    Check = "Check",
    DebitCard = "Payroll Visa Debit Card",
    DirectDeposit = "Direct Deposit",
  }


// WEBPACK FOOTER //
// ./src/app/shared/enums/payment-methods-select.enum.ts